import { useQuery } from "@tanstack/react-query";
import { getRebuildAPI } from "@rebuild/shared/api";
import { PHOTO_REPORT_LETTERHEAD_KEYS } from "./queryKeys";

const { estimatesControllerGetPhotoReportLetterhead } = getRebuildAPI();

/**
 * Fetch the org's applicable letterhead logo (as a temporary URL) so the photo-report preview can
 * mirror the branding the exported PDF renders. Disabled until an estimateId is provided (i.e. the
 * export dialog is open). Resolves with an empty `url` when the org has no configured letterhead.
 */
export function useGetPhotoReportLetterheadQuery(estimateId: string | undefined) {
  return useQuery({
    queryKey: PHOTO_REPORT_LETTERHEAD_KEYS.estimate(estimateId ?? ""),
    queryFn: () => estimatesControllerGetPhotoReportLetterhead(estimateId ?? ""),
    enabled: !!estimateId,
    staleTime: 5 * 60 * 1000,
  });
}
